import { loadAuth, useAuthStore } from "~/components/_refactored/auth";

/**
 * Preload store data for pinia
 */
export default async (context) => {
  if (process.server) {
    // Load data on the server side
    await Promise.all([loadAuth(context)]);
  }
  if (process.client) {
    // Auth state is hydrated from the server payload (loginWithToken does not
    // re-run on the client), so the favourites cache — a client-only concern —
    // would otherwise never be populated on a normal page load. Load it here.
    useAuthStore(context.$pinia).loadFavourites();
  }
};
